import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=6af867ce&scoped=true"
import script from "./Prescriptions.vue?vue&type=script&lang=js"
export * from "./Prescriptions.vue?vue&type=script&lang=js"
import style0 from "./Prescriptions.vue?vue&type=style&index=0&id=6af867ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af867ce",
  null
  
)

export default component.exports